import { ISidebarRoutesSectionOption, ISidebarRoutesSubSection } from '@/interfaces/routing/ISidebarRoutes.ts';
import { assetsRoutes } from '../assetsRoutes.ts';

export const assetsSidebarInfo: Array<ISidebarRoutesSectionOption | ISidebarRoutesSubSection> = [
    {
        sectionName: 'Storage',
        icon: ['fas', 'battery-bolt'],
        pages: [
            {
                name: 'Overview',
                route: assetsRoutes.overview.name as string,
                icon: ['fad', 'house'],
                availableOnMobile: true,
            },
            {
                name: 'Market Trends',
                route: assetsRoutes.marketTrends.name as string,
                icon: ['fad', 'chart-line-up'],
                availableOnMobile: true,
            },
            {
                name: 'Rankings',
                route: assetsRoutes.rankings.name as string,
                icon: ['fad', 'ranking-star'],
                availableOnMobile: true,
            },
            {
                name: 'Company Search',
                route: assetsRoutes.companySearch.name as string,
                icon: ['fad', 'building'],
                availableOnMobile: true,
            },
            {
                name: 'Project Search',
                route: assetsRoutes.projectSearch.name as string,
                icon: ['fad', 'notebook'],
                availableOnMobile: true,
            },
            {
                name: 'Custom Charting',
                route: assetsRoutes.customCharting.name as string,
                icon: ['fad', 'chart-user'],
                availableOnMobile: true,
            },
            {
                name: 'Project Updates',
                route: assetsRoutes.projectUpdates.name as string,
                icon: ['fad', 'clock'],
                availableOnMobile: true,
            },
        ],
    },
    {
        name: 'Plant Table',
        route: assetsRoutes.plantTable.name as string,
        icon: ['fad', 'table'],
        availableOnMobile: true,
    },
    {
        name: 'Registers',
        route: assetsRoutes.registers.name as string,
        icon: ['fad', 'clipboard-list'],
        availableOnMobile: true,
        tags: ['GB'],
    },
];
